import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductComponentBaseProductMutation(
    $productComponentBaseProduct: ProductComponentBaseProductInput!
  ) {
    createProductComponentBaseProduct(
      input: { productComponentBaseProduct: $productComponentBaseProduct }
    ) {
      productComponentBaseProduct {
        id
      }
    }
  }
`;
